// Origin of the AI API (fapi) — a different host from the Rails API that `getApiUrl` returns.
// The feed-view page calls fapi straight from the browser, so this is the one place that origin
// is resolved. Mirrors src/utils/apiUrl.js: env first, prod host as the fallback.
export const getAiApiUrl = () => process.env.REACT_APP_AI_API_URL || 'https://ai-api.tornado.com';
